exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "upload:not(.btn){display:block;clear:both}upload:not(.btn) label{font-weight:400;margin-bottom:0}upload:not(.btn) i{position:relative;top:7px}upload span{font-size:12px}upload label{height:36px;width:200px;color:#fff!important}upload label>md-progress-circular{margin:auto;margin-top:7px}upload label>md-progress-circular .md-left>.md-half-circle{border-left-color:#fff}upload label>md-progress-circular .md-right>.md-half-circle{border-right-color:#fff}upload .upload-disabled{background:rgba(238,39,55,.2)!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./sources/utility/upload/upload.scss
// module id = 887
// module chunks = 0